export default __webpack_public_path__ + "static/media/avater7.4a34de8f.png";